import React from 'react';
const segmentsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/admin-segments',
			component: React.lazy(() => import('../../company-profile/customerAccountDetails/SideNavigationPages/segments/Segment'))
		},
		
	]
};
export default segmentsConfig;
